import { defineMessages, IntlShape } from 'react-intl';

/** The `cause` of a refused post write, as `customBaseQuery` puts it on the error (`m24Limit`). */
function causeOf(error: unknown): Record<string, unknown> | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const cause = (error as { m24Limit?: unknown }).m24Limit;
  return typeof cause === 'object' && cause !== null ? (cause as Record<string, unknown>) : null;
}

const messages = defineMessages({
  // Owner report 2026-10-10: say which answer is missing and where to give it.
  required: {
    id: 'app.sml.promote.error.answerMissing',
    defaultMessage:
      'One answer is missing: who can see this post. TikTok and YouTube ask you to choose it. Open the post and answer in its TikTok or YouTube section.',
  },
  watermark: {
    id: 'app.sml.promote.error.tiktokWatermark',
    defaultMessage:
      'TikTok does not take a video with the MUSIC24 mark. Upgrade and make a new version, or attach your own video.',
  },
  privacyMissing: {
    id: 'app.sml.promote.error.settings.privacyMissing',
    defaultMessage: 'Choose who can see the post.',
  },
  brandedPrivate: {
    id: 'app.sml.promote.error.settings.brandedPrivate',
    defaultMessage: 'Branded content cannot be private. Choose another level.',
  },
  disclosureEmpty: {
    id: 'app.sml.promote.error.settings.disclosureEmpty',
    defaultMessage: 'Choose Your brand or Branded content, or turn the disclosure off.',
  },
  generic: {
    id: 'app.sml.promote.error.settings.generic',
    defaultMessage: 'These post settings are not possible. Check them again.',
  },
});

const REASON_MESSAGES: Record<string, (typeof messages)[keyof typeof messages]> = {
  privacyMissing: messages.privacyMissing,
  brandedPrivate: messages.brandedPrivate,
  disclosureEmpty: messages.disclosureEmpty,
};

/**
 * One sentence for a post write that the server refused because of the platform settings, or
 * undefined for any other error (the caller says it in its own way).
 */
export function postSettingsErrorMessage(intl: IntlShape, error: unknown): string | undefined {
  const cause = causeOf(error);
  switch (cause?.code) {
    case 'M24_POST_SETTINGS_REQUIRED':
      return intl.formatMessage(messages.required);
    case 'M24_TIKTOK_WATERMARK':
      return intl.formatMessage(messages.watermark);
    case 'M24_POST_SETTINGS_INVALID': {
      const reason = typeof cause.reason === 'string' ? REASON_MESSAGES[cause.reason] : undefined;
      return intl.formatMessage(reason ?? messages.generic);
    }
    default:
      return undefined;
  }
}
